var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2D3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1760 4489 c-116 -20 -221 -92 -273 -187 -32 -59 -57 -151 -57 -209 l0 -43 79 0 78 0 11 67 c22 132 99 211 216 220 155 13 238 -56 253 -210 19 -204 -120 -400 -529 -750 l-118 -101 0 -63 0 -63 428 2 427 3 0 70 0 70 -293 5 -294 5 84 72 c205 176 377 384 426 516 79 211 37 425 -104 526 -85 62 -219 89 -334 70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2642 3778 l3 -643 190 -3 c382 -6 551 41 691 191 122 131 181 340 155 547 -30 237 -141 400 -332 490 -110 51 -175 60 -457 60 l-252 0 2 -642z m565 474 c132 -42 228 -135 273 -264 30 -88 38 -267 16 -362 -45 -192 -174 -309 -369 -335 -43 -6 -130 -11 -193 -11 l-114 0 0 501 0 502 163 -6 c123 -4 177 -10 224 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 2584 c-9 -11 -10 -20 -2 -32 9 -16 173 -17 2288 -17 2115 0 2279 1 2288 17 8 12 7 21 -2 32 -12 15 -225 16 -2286 16 -2061 0 -2274 -1 -2286 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 1994 c-184 -29 -311 -151 -338 -326 l-6 -38 84 0 c84 0 85 0 91 28 11 43 40 95 71 124 43 41 94 58 176 58 91 0 149 -26 191 -88 27 -37 30 -51 31 -115 0 -63 -4 -79 -27 -114 -41 -63 -113 -94 -235 -102 l-98 -6 0 -75 0 -75 100 -6 c199 -11 284 -84 285 -243 0 -112 -58 -200 -147 -225 -51 -14 -146 -14 -195 1 -78 23 -157 115 -173 201 l-7 38 -82 -3 -81 -3 3 -30 c11 -108 66 -214 144 -275 163 -129 465 -122 601 14 102 101 132 288 72 433 -22 52 -100 128 -157 153 l-52 22 52 25 c165 78 217 329 101 487 -37 51 -111 103 -174 122 -53 16 -179 25 -230 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1274 l0 -647 258 6 c216 4 269 8 333 25 220 59 365 203 425 422 25 89 25 299 1 390 -47 177 -148 305 -297 379 -127 62 -184 71 -472 71 l-248 0 0 -646z m502 492 c232 -42 358 -212 358 -483 0 -173 -33 -276 -120 -367 -95 -100 -211 -135 -452 -136 l-118 0 0 500 0 500 128 0 c70 -1 162 -7 204 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D3D);
export default __webpack_public_path__ + "static/media/2d-3d.9e5a121d52f9671e3f823fa87ef22079.svg";
export { ForwardRef as ReactComponent };